export { default as Bold } from './Bold';
